import { Button as AntdButton } from 'antd';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const CartButton = styled(AntdButton)`
  background-color: #F5F5F5;
  color: #000000;
  border-color: #F5F5F5;
  border: 1px solid #d9d9d9;

  &:hover {
    background-color: #E8E8E8;
    color: #000000;
    border-color: #E8E8E8;
  }

  &:focus {
    background-color: #F5F5F5;
    color: #000000;
    border-color: #F5F5F5;
  }

  @media (max-width: ${BREAKPOINTS.desktop}) {
    .ant-btn-icon + span {
      display: none;
    }

    .anticon {
      margin: 0 !important;
    }

    min-width: 32px;
  }
`;
